/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    google: true,
    apple: true,
};
export const quickPaySlice = createSlice({
    name: 'quickPayReducer',
    initialState,
    reducers: {
        updateQuickPayState: (state, action) => {
            console.log(`Setting ${action.payload.type} to ${action.payload.value}`);
            state[action.payload.type] = !!action.payload.value;
            // state.apple = true;
        },
    },
});
export const { updateQuickPayState } = quickPaySlice.actions;
// eslint-disable-next-line max-len
export const setQuickPayState = (type, value) => (dispatch) => Promise.resolve(dispatch(updateQuickPayState({ type, value })));
export const getQuickPayGoogleState = (state) => state.quickPay.google;
export const getQuickPayAppleState = (state) => state.quickPay.apple;
export const getQuickPayState = (state) => ({
    apple: state.quickPay.apple,
    google: state.quickPay.google,
});
export default quickPaySlice.reducer;
